import { Controller } from 'stimulus'

// Matches $card-actions-toggle in _card-collapsible.scss
const DURATION = 150

// Tablets and phones: a collapsible card (tracks, access links, subscribers)
// shows its artwork, details and a ⋮ button. The ⋮ button (only) opens and
// closes its actions. Desktop cards always show their actions and hide the ⋮.
export default class extends Controller {
  static targets = ['more']

  toggle(event) {
    event.preventDefault()
    // Open cards wrap their details instead of cutting them short with "…",
    // so the text grows or shrinks - animate between the two heights (the
    // vertically centred title moves with it) rather than jumping
    const details = this.element.querySelector('.card__content__details')
    const from = details?.offsetHeight

    this.open = !this.element.classList.contains('card--open')

    if (details) this.animateHeight(details, from, details.offsetHeight)
  }

  set open(open) {
    this.element.classList.toggle('card--open', open)
    if (this.hasMoreTarget) this.moreTarget.setAttribute('aria-expanded', String(open))
  }

  animateHeight(element, from, to) {
    if (from === to || !element.animate) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    element.style.overflow = 'hidden'
    const animation = element.animate(
      [{ height: `${from}px` }, { height: `${to}px` }],
      { duration: DURATION, easing: 'ease-out' }
    )
    animation.onfinish = animation.oncancel = () => { element.style.overflow = '' }
  }
}
